import React, { useState, useEffect } from "react";

import { CButton, CTooltip } from "@coreui/react";
import { useSelector } from "react-redux";

import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { arrayToCSV, elementToPDF } from "../../../../utils/export";
import CorrectQuestionList from "../../../CorrectQuestionList";
import LoadingStatistics from "../../../LoadingStatistics";
import StatisticFiltersCompare from "../../../StatisticFiltersCompare";
import ComparisonStudentsClassroom from "../AlunoTurma";

import "./styles.scss";

const ListaNotasFiltro = ({ activity_id: activityId, room_id: roomId }) => {
  const token = useSelector(state => state.user.token);

  const [questionListModal, setQuestionListModal] = useState(false);
  const [comparisonStudent, setComparisonStudent] = useState(false);
  const [grade, setGrade] = useState({});
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);

  const changeFilter = selected => {
    setLoading(true);
    setGroupId(selected.groupId);
    setRegionId(selected.regionId);
    setSchoolId(selected.schoolId);

    const params = {
      group_id: selected.groupId,
      region_id: selected.regionId,
      school_id: selected.schoolId,
      room_id: selected.roomId,
      activity_id: activityId
    };

    axios
      .get(`${URL.api}statistics/evaluation_grades`, {
        params,
        headers: { authorization: `Bearer ${token}` }
      })
      .then(resp => {
        setData(resp.data.data);
        setLoading(false);
      });
  };

  const showGrade = (e, grade) => {
    e.preventDefault();
    e.stopPropagation();

    if (grade.grade) {
      setQuestionListModal(true);
      setGrade(grade);
    }
  };

  const showComparison = (e, grade) => {
    e.preventDefault();
    e.stopPropagation();

    if (grade.grade) {
      setComparisonStudent(true);
      setGrade(grade);
    }
  };

  const getGradesCSV = data => {
    const header = ["aluno", "nota", "tentativas"];

    const arr = [header];

    data.forEach(student => {
      arr.push([student.name, student.grade || "", student.tries]);
    });

    return arr;
  };

  const getArray = data => {
    const header = [
      "total_alunos",
      "alunos_executaram",
      "alunos_nao_executaram",
      "menor_nota",
      "maior_nota",
      "nota_media"
    ];

    const arr = [header];

    arr.push([
      data.total,
      data.num_applications,
      data.total - data.num_applications,
      data.min_grade || "",
      data.max_grade || "",
      data.avg_grade || ""
    ]);

    return arr;
  };

  return (
    <>
      {questionListModal && data && (
        <CorrectQuestionList
          show
          onClose={() => setQuestionListModal(false)}
          activityId={grade.activity_id}
          allocation_id={grade.allocation_id}
          id={grade.list_id}
          item_id={grade.item_id}
          execution_id={grade.execution_id}
          user_id={grade.id}
        />
      )}
      {comparisonStudent && data && (
        <ComparisonStudentsClassroom
          show
          onClose={() => setComparisonStudent(false)}
          activityId={activityId}
          name={grade.name}
          userId={grade.id}
          groupId={groupId}
          regionId={regionId}
          schoolId={schoolId}
          roomId={roomId}
        />
      )}
      <div className="divToPrint d-flex flex-column align-items-center w-100">
        <div className="layoutTabelaComparacao flex-column w-100">
          <StatisticFiltersCompare
            activityId={activityId}
            onChange={changeFilter}
            hideUser
          />
        </div>
        <div className="w-100" id="allGrades">
          {loading ? (
            <LoadingStatistics />
          ) : (
            <>
              {data?.summary && (
                <div className="w-100">
                  <div className="w-100 d-flex flex-row-reverse mb-2 d-false">
                    <CButton
                      id="printBtn"
                      color="link"
                      className="text-muted p-0"
                      size="sm"
                      onClick={() =>
                        arrayToCSV(getArray(data.grades), "Lista de Notas.csv")
                      }
                    >
                      <i className="fa fa-file-pdf-o mr-2"></i> Exportar para
                      CSV
                    </CButton>
                    <span className="mx-2">|</span>
                    <CButton
                      id="printBtn"
                      color="link"
                      className="text-muted p-0"
                      size="sm"
                      onClick={() =>
                        elementToPDF("allGrades", "Lista de Notas.pdf")
                      }
                    >
                      <i className="fa fa-file-pdf-o mr-2"></i> Exportar para
                      PDF
                    </CButton>
                  </div>
                  <div className="w-100" id="resumo">
                    <table className="table table-hover table-outline mb-4 d-none d-sm-table w-100">
                      <thead className="thead-light">
                        <tr>
                          <th>Total de estudantes</th>
                          <th>Estudante que executaram</th>
                          <th>Estudante que não executaram</th>
                          <th>Menor Nota</th>
                          <th>Maior Nota</th>
                          <th>Média</th>
                          <th>Média do grupo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{data.summary.total}</td>
                          <td>{data.summary.num_applications}</td>
                          <td>
                            {data.summary.total - data.summary.num_applications}
                          </td>
                          <td>
                            {data.summary.min_grade !== null
                              ? Number(data.summary.min_grade).toFixed(2)
                              : ""}
                          </td>
                          <td>
                            {data.summary.max_grade !== null
                              ? Number(data.summary.max_grade).toFixed(2)
                              : ""}
                          </td>
                          <td>
                            {data.summary.avg_grade !== null
                              ? Number(data.summary.avg_grade).toFixed(2)
                              : ""}
                          </td>
                          <td>
                            {data.summary.avg_group_grade !== null
                              ? Number(data.summary.avg_group_grade).toFixed(2)
                              : ""}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </>
          )}
          {data && data.grades && (
            <div className="w-100">
              <div className="w-100" id="porAluno">
                <table className="table table-hover table-outline mb-0 d-none d-sm-table w-100 mb-4">
                  <thead className="thead-light">
                    <tr>
                      <th>Nº</th>
                      <th>Estudante</th>
                      <th>Nota</th>
                      <th>Tentativas</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.grades.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="c-avatar mr-3">
                              <img
                                src={
                                  URL.img +
                                  (item.photo ||
                                    "uploads/users/profileEmpty.jpg")
                                }
                                className="c-avatar-img"
                                alt="imagem"
                              />
                            </div>
                            {item.name}
                          </div>
                        </td>
                        <td>{item.grade}</td>
                        <td>{item.tries}</td>
                        <td>
                          <CTooltip content="Visualizar">
                            <CButton
                              type="button"
                              className="btn btn-info mr-2"
                              onClick={e => showGrade(e, item)}
                            >
                              <i className="fa fa-eye"></i>
                            </CButton>
                          </CTooltip>
                          <CTooltip content="Comparação">
                            <CButton
                              type="button"
                              className="btn btn-warning"
                              onClick={e => showComparison(e, item)}
                            >
                              <i className="fa fa-list"></i>
                            </CButton>
                          </CTooltip>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ListaNotasFiltro;
